export class MenuItem {
    constructor() {
        /**
         * Gets or sets the id of the menu item
         */
        this.id = '';
        /**
         * Gets or sets the title of the menu
         */
        this.text = '';
        /**
         * Gets or sets the icon of the menu
         */
        this.icon = '';
        /**
         * Default selected item
         */
        this.selected = false;
        /**
         * Gets or sets if the menu has separator.
         */
        this.hasSeparator = false;
        /**
         * Gets or sets the children of the menu
         */
        this.children = [];
    }
    /**
     * Override serialization of the object. Compatibility with Javascript
     * @returns Object serialized
     */
    toString() {
        return JSON.stringify(this);
    }
}
//# sourceMappingURL=menu-item.js.map